// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Toastify__toast {
  border-radius: 8px;
  font: inherit;
  font-weight: 500;
  font-size: 0.875rem;
  display: flex;
  align-items: center;
  color: #fff;
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  padding: 12px 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.Toastify__toast--success {
  background: rgba(65, 105, 225, 0.85);
  /* border-left: 4px solid #4169E1; */
}

/* Override the success icon color - using multiple selectors for better specificity */
.Toastify__toast--success .Toastify__toast-icon svg,
.Toastify__toast--success .Toastify__toast-icon svg path,
.Toastify__toast-icon--success,
.Toastify__toast--success svg,
.Toastify__toast--success svg path {
  fill: #4169E1 !important;
  color: #4169E1 !important;
  stroke: #4169E1 !important;
}

.Toastify__toast--info {
  background: rgba(25, 118, 210, 0.85);
  /* border-left: 4px solid #2196f3; */
}

.Toastify__toast--warning {
  background: rgba(237, 108, 2, 0.85);
  /* border-left: 4px solid #ff9800; */
}

.Toastify__toast--error {
  background: rgba(211, 47, 47, 0.85);
  /* border-left: 4px solid #f44336; */
}

.Toastify__close-button {
  height: fit-content;
  align-self: center;
  opacity: 0.7;
  transition: opacity 0.2s ease;
}

.Toastify__close-button:hover {
  opacity: 1;
}

.Toastify__progress-bar {
  height: 3px;
}

.Toastify__progress-bar--success {
  background-color: #4169E1;
}

/* Dark mode adjustments */
.Toastify__toast-theme--dark {
  background: rgba(40, 40, 40, 0.85);
  color: #fff;
}

/* Light mode adjustments */
.Toastify__toast-theme--light {
  background: rgba(255, 255, 255, 0.9);
  color: #333;
  border: 1px solid rgba(0, 0, 0, 0.1);
}
`, "",{"version":3,"sources":["webpack://./src/toast.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,2BAA2B;EAC3B,yCAAyC;EACzC,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA,sFAAsF;AACtF;;;;;EAKE,wBAAwB;EACxB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,0BAA0B;AAC1B;EACE,kCAAkC;EAClC,WAAW;AACb;;AAEA,2BAA2B;AAC3B;EACE,oCAAoC;EACpC,WAAW;EACX,oCAAoC;AACtC","sourcesContent":[".Toastify__toast {\n  border-radius: 8px;\n  font: inherit;\n  font-weight: 500;\n  font-size: 0.875rem;\n  display: flex;\n  align-items: center;\n  color: #fff;\n  backdrop-filter: blur(10px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n  padding: 12px 16px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.Toastify__toast--success {\n  background: rgba(65, 105, 225, 0.85);\n  /* border-left: 4px solid #4169E1; */\n}\n\n/* Override the success icon color - using multiple selectors for better specificity */\n.Toastify__toast--success .Toastify__toast-icon svg,\n.Toastify__toast--success .Toastify__toast-icon svg path,\n.Toastify__toast-icon--success,\n.Toastify__toast--success svg,\n.Toastify__toast--success svg path {\n  fill: #4169E1 !important;\n  color: #4169E1 !important;\n  stroke: #4169E1 !important;\n}\n\n.Toastify__toast--info {\n  background: rgba(25, 118, 210, 0.85);\n  /* border-left: 4px solid #2196f3; */\n}\n\n.Toastify__toast--warning {\n  background: rgba(237, 108, 2, 0.85);\n  /* border-left: 4px solid #ff9800; */\n}\n\n.Toastify__toast--error {\n  background: rgba(211, 47, 47, 0.85);\n  /* border-left: 4px solid #f44336; */\n}\n\n.Toastify__close-button {\n  height: fit-content;\n  align-self: center;\n  opacity: 0.7;\n  transition: opacity 0.2s ease;\n}\n\n.Toastify__close-button:hover {\n  opacity: 1;\n}\n\n.Toastify__progress-bar {\n  height: 3px;\n}\n\n.Toastify__progress-bar--success {\n  background-color: #4169E1;\n}\n\n/* Dark mode adjustments */\n.Toastify__toast-theme--dark {\n  background: rgba(40, 40, 40, 0.85);\n  color: #fff;\n}\n\n/* Light mode adjustments */\n.Toastify__toast-theme--light {\n  background: rgba(255, 255, 255, 0.9);\n  color: #333;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
